module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "big-form"
    }
  }, [_c('db-breadcrumb'), _vm._v(" "), _c('div', {
    staticClass: "db-content-inner"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "placeholder": "请输入您的姓名"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        _vm.form.name = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "gender"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.gender),
      expression: "form.gender"
    }],
    domProps: {
      "value": (_vm.form.gender)
    },
    on: {
      "input": function($event) {
        _vm.form.gender = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "男"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "女"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日",
      "prop": "birthday"
    }
  }, [_c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.birthday),
      expression: "form.birthday"
    }],
    attrs: {
      "type": "date",
      "placeholder": "请输入您的生日"
    },
    domProps: {
      "value": (_vm.form.birthday)
    },
    on: {
      "input": function($event) {
        _vm.form.birthday = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作年限",
      "prop": "workDuration"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.workDuration),
      expression: "form.workDuration"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.workDuration)
    },
    on: {
      "input": function($event) {
        _vm.form.workDuration = $event
      }
    }
  }, _vm._l((_vm.workDurationOptions), function(option) {
    return _c('el-option', {
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最高学历",
      "prop": "academic"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.academic),
      expression: "form.academic"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.academic)
    },
    on: {
      "input": function($event) {
        _vm.form.academic = $event
      }
    }
  }, _vm._l((_vm.academicOptions), function(option) {
    return _c('el-option', {
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校",
      "prop": "school"
    }
  }, [_c('el-autocomplete', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.school),
      expression: "form.school"
    }],
    attrs: {
      "fetch-suggestions": _vm.getSchoolsInfo,
      "placeholder": "请输入您的学校"
    },
    domProps: {
      "value": (_vm.form.school)
    },
    on: {
      "select": _vm.handleSelectSchool,
      "input": function($event) {
        _vm.form.school = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专业",
      "prop": "major"
    }
  }, [_c('el-autocomplete', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.major),
      expression: "form.major"
    }],
    attrs: {
      "disabled": !_vm.form.school,
      "fetch-suggestions": _vm.getMajorsInfo,
      "placeholder": "请输入您的专业"
    },
    domProps: {
      "value": (_vm.form.major)
    },
    on: {
      "input": function($event) {
        _vm.form.major = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "在职公司",
      "prop": "company"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.company),
      expression: "form.company"
    }],
    attrs: {
      "placeholder": "请输入您目前所在的公司名称"
    },
    domProps: {
      "value": (_vm.form.company)
    },
    on: {
      "input": function($event) {
        _vm.form.company = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位",
      "prop": "position"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.position),
      expression: "form.position"
    }],
    attrs: {
      "placeholder": "请输入您的职位名称"
    },
    domProps: {
      "value": (_vm.form.position)
    },
    on: {
      "input": function($event) {
        _vm.form.position = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.city),
      expression: "form.city"
    }],
    attrs: {
      "placeholder": "请输入您意向的工作地点"
    },
    domProps: {
      "value": (_vm.form.city)
    },
    on: {
      "input": function($event) {
        _vm.form.city = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系方式",
      "prop": "phone"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    attrs: {
      "placeholder": "请输入您的联系方式"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        _vm.form.phone = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    attrs: {
      "placeholder": "请输入您的邮箱"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        _vm.form.email = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "网站",
      "prop": "website"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.website),
      expression: "form.website"
    }],
    attrs: {
      "placeholder": "请输入您的个人博客"
    },
    domProps: {
      "value": (_vm.form.website)
    },
    on: {
      "input": function($event) {
        _vm.form.website = $event
      }
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("http://")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "技能",
      "prop": "skills"
    }
  }, [_vm._l((_vm.form.skills), function(skill, index) {
    return _c('el-row', {
      staticClass: "skill-line",
      attrs: {
        "type": "flex",
        "align": "middle"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skill.name),
        expression: "skill.name"
      }],
      attrs: {
        "placeholder": "请输入技能"
      },
      domProps: {
        "value": (skill.name)
      },
      on: {
        "input": function($event) {
          skill.name = $event
        }
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12,
        "offset": 1
      }
    }, [_c('el-slider', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skill.value),
        expression: "skill.value"
      }],
      domProps: {
        "value": (skill.value)
      },
      on: {
        "input": function($event) {
          skill.value = $event
        }
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6,
        "offset": 1
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteSkill(index)
        }
      }
    }), _vm._v(" "), (index === _vm.form.skills.length - 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "plus"
      },
      on: {
        "click": _vm.addSkill
      }
    }) : _vm._e()], 1)], 1)
  }), _vm._v(" "), (_vm.form.skills.length <= 0) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6,
      "offset": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addSkill
    }
  }, [_vm._v("添加技能")])], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "个人简历"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "/resume",
      "type": "drag",
      "accept": "pdf",
      "before-upload": _vm.uploadResume,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "default-file-list": _vm.resume
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    slot: "tip"
  }, [_vm._v("只能上传pdf文件，且不超过5M")])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51dad2fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/form/big-form.vue
// module id = 558
// module chunks = 2